import { ref } from "vue";
import { getAllLeads , deleteLead , updateLead, addLead , filter ,getUserLeads , getLeadActions , assignLead} from "@/api/lead";

const state = {
    leads: ref({}),
    isLoading: ref(false),
    lists: ref({}),
    user:ref({}),
    actions: ref({}),
    statistics:ref({}),
};
const actions = {
    async fetchLeads({commit} , page){
        try{
            const response = await getAllLeads(page);
            commit('SET_LEADS' , response.leads);
            commit('SET_LISTS' , response.lists);
        }catch(error){
            console.log(error)
        }
    },
    async assignLeads({commit} ,data){
        try{
            const res = await assignLead(data);
            commit('UPDATE_LEADS' , res.leads);
        }catch(error){
            console.log(error)
        }
    },
    async fetchUserLeads({commit} , {id ,page}){
        try{
            const response = await getUserLeads(id,page);
            commit('SET_LEADS' , response.leads);
            commit('SET_LISTS' , response.lists);
            commit('SET_USER' , response.user);
        }catch(error){
            console.log(error);
        }
    },
    async addNewLead({commit} , lead){
        try{
            const resLead = await addLead(lead);
            commit('ADD_LEAD' , resLead.data.lead);
        }catch(error){
            console.log(error)
        }
    },
    async deleteLead({commit} , id){
        try{
            await deleteLead(id);
            commit('DELETE_LEAD' , id);

        }catch(e){
            console.log(e);
        }
    },
    async updateLead({commit} , lead){
        try{
            const response = await updateLead(lead);
            commit('UPDATE_LEAD' , response);
        }catch(e){
            throw new Error(e);
        }
    },
    async filter({commit} , {form , page}){
        try{
            const response = await filter(form , page);
            commit('SET_LEADS' , response.leads);
            commit('SET_STATISTICS' , response.statistics);
        }catch(e){
            throw new Error(e);
        }
    },
    async fetchLeadActions({ commit }, { leadId, page }) {
        try {
            const response = await getLeadActions(leadId, page);
            commit('ADD_LEAD_ACTIONS', response);
            
        } catch (error) {
            console.error(error);
        }
    }

};
const mutations = {
    ADD_LEAD_ACTIONS(state, actions) {
        state.actions = actions;
    },
    SET_LEADS(state , leads){
        state.leads = leads;
        state.leads.data = state.leads.data.map(lead => ({
            ...lead,
            is_lead_show:false,
            is_lead_edit:false,
            is_filter_opens:false,
        }))
    },
    SET_USER(state , user){
        state.user = user;
    },
    DELETE_LEAD(state , id){
        state.leads.data = state.leads.data.filter(lead => lead.id !== id);
    },
    UPDATE_LEAD(state , updatedlead){
        state.leads.data.map((lead,index) => lead.id == updatedlead.id ? state.leads.data[index] = {
            ...updatedlead,
            is_lead_show:true,
            is_lead_edit:false,
            is_filter_opens:false,
        } : null);
    },
    UPDATE_LEADS(state , updatedLeads){
        updatedLeads.forEach(updatedLead => {
            const index = state.leads.data.findIndex(lead => lead.id === updatedLead.id);
            if (index !== -1) {
                state.leads.data[index] = {
                    ...updatedLead,
                    is_lead_show: true,
                    is_lead_edit: false,
                    is_filter_opens: false,
                };
            }
        });
    },
    SET_LISTS(state, lists){
        state.lists = lists;
    },
    ADD_LEAD(state , lead){
        console.log(lead);
        state.leads.data.unshift({
            ...lead,
            is_lead_show:false,
            is_edit_active:false,
        });
    },
    SET_STATISTICS(state,response){
        state.statistics = response;
    }
};

const getters = {
    getLeads: (state) => state.leads,
    getUser: (state) => state.user,
    getLists:(state) => state.lists,
    getLeadActions: (state) => state.actions,
    getStatistics:(state) => state.statistics,
};

export default {
    namespaced: true,
    state , 
    getters,
    mutations,
    actions
};